import { render, staticRenderFns } from "./Scenes2.vue?vue&type=template&id=47547cb0&scoped=true&lang=pug&"
import script from "./Scenes2.vue?vue&type=script&lang=js&"
export * from "./Scenes2.vue?vue&type=script&lang=js&"
import style0 from "./Scenes2.vue?vue&type=style&index=0&id=47547cb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47547cb0",
  null
  
)

export default component.exports